export const summaryDetailsColumnData = [
  {
    columnName: "totalFeesWithoutFpa",
    columnDisplayName: "Συνολική χρέωση χωρίς ΦΠΑ",
    visible: true,
    columnOrder: 1,
    isDraggable: false,
    columnDataType: "Double"
  },
  {
    columnName: "addTotalFeesWithoutFpa",
    columnDisplayName: "Συνολική επιπλέον χρέωση χωρίς ΦΠΑ",
    visible: true,
    columnOrder: 2,
    isDraggable: false,
    columnDataType: "Double"
  },
  {
    columnName: "fpa0",
    columnDisplayName: "ΦΠΑ 0%",
    visible: true,
    columnOrder: 3,
    isDraggable: false,
    columnDataType: "Double"
  },
  {
    columnName: "fpa13",
    columnDisplayName: "ΦΠΑ 13%",
    visible: true,
    columnOrder: 4,
    isDraggable: false,
    columnDataType: "Double"
  },
  {
    columnName: "fpa15",
    columnDisplayName: "ΦΠΑ 15%",
    visible: true,
    columnOrder: 5,
    isDraggable: false,
    columnDataType: "Double"
  },
  {
    columnName: "fpa16",
    columnDisplayName: "ΦΠΑ 16%",
    visible: true,
    columnOrder: 6,
    isDraggable: false,
    columnDataType: "Double"
  },
  {
    columnName: "fpa17",
    columnDisplayName: "ΦΠΑ 17%",
    visible: true,
    columnOrder: 7,
    isDraggable: false,
    columnDataType: "Double"
  },
  {
    columnName: "fpa18",
    columnDisplayName: "ΦΠΑ 17%",
    visible: true,
    columnOrder: 8,
    isDraggable: false,
    columnDataType: "Double"
  },
  {
    columnName: "fpa19",
    columnDisplayName: "ΦΠΑ 17%",
    visible: true,
    columnOrder: 9,
    isDraggable: false,
    columnDataType: "Double"
  },
  {
    columnName: "fpa21",
    columnDisplayName: "ΦΠΑ 17%",
    visible: true,
    columnOrder: 10,
    isDraggable: false,
    columnDataType: "Double"
  },
  {
    columnName: "fpa23",
    columnDisplayName: "ΦΠΑ 17%",
    visible: true,
    columnOrder: 11,
    isDraggable: false,
    columnDataType: "Double"
  },
  {
    columnName: "fpa24",
    columnDisplayName: "ΦΠΑ 24%",
    visible: true,
    columnOrder: 12,
    isDraggable: false,
    columnDataType: "Double"
  },
  {
    columnName: "totalWithoutFpa",
    columnDisplayName: "Γενικό σύνολο χωρις ΦΠΑ",
    visible: true,
    columnOrder: 13,
    isDraggable: false,
    columnDataType: "Double"
  },
  {
    columnName: "totalFpa",
    columnDisplayName: "Γενικό σύνολο ΦΠΑ",
    visible: true,
    columnOrder: 14,
    isDraggable: false,
    columnDataType: "Double"
  },
  {
    columnName: "totalWithFpa",
    columnDisplayName: "Γενικό σύνολο με ΦΠΑ",
    visible: true,
    columnOrder: 15,
    isDraggable: false,
    columnDataType: "Double"
  }
];

export const summaryLinesColumnData = (footerData: IGetBillingSummaryLinesSummary | undefined) => {
  console.log("footerData", footerData)
  return [
    {
      columnName: "phoneNumber",
      columnDisplayName: "Αριθμός",
      visible: true,
      columnOrder: 1,
      isDraggable: false,
      columnDataType: "Integer",
    },
    {
      columnName: "provider",
      columnDisplayName: "Πάροχος",
      visible: true,
      columnOrder: 2,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "unID",
      columnDisplayName: "Κωδ. Κατ.",
      visible: true,
      columnOrder: 3,
      isDraggable: false,
      columnDataType: "String"
    },
    {
      columnName: "sapCode",
      columnDisplayName: "Κωδικός SAP",
      visible: true,
      columnOrder: 4,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "onceFees",
      columnDisplayName: "Εφάπαξ",
      visible: true,
      columnOrder: 5,
      isDraggable: false,
      columnDataType: "Double",
      columnFooter: <>{footerData?.onceFees}</>
    },
    {
      columnName: "monthlyFees",
      columnDisplayName: "Πάγιο",
      visible: true,
      columnOrder: 6,
      isDraggable: false,
      columnDataType: "Double",
      columnFooter: <>{footerData?.monthlyFees}</>
    },
    {
      columnName: "usageFees",
      columnDisplayName: "Χρέωση",
      visible: true,
      columnOrder: 7,
      isDraggable: false,
      columnDataType: "Double",
      columnFooter: <>{footerData?.usageFees}</>
    },
    {
      columnName: "totalFees",
      columnDisplayName: "Σύνολο",
      visible: true,
      columnOrder: 8,
      isDraggable: false,
      columnDataType: "Double",
      columnFooter: <>{footerData?.totalFees}</>
    },
    {
      columnName: "oteFpa",
      columnDisplayName: "ΦΠΑ",
      visible: true,
      columnOrder: 9,
      isDraggable: false,
      columnDataType: "Double",
    },
    {
      columnName: "posoFpa",
      columnDisplayName: "Ποσό ΦΠΑ",
      visible: true,
      columnOrder: 10,
      isDraggable: false,
      columnDataType: "Double",
      columnFooter: <>{footerData?.posoFpa}</>
    },
    {
      columnName: "actualFees",
      columnDisplayName: "Σύνολο με ΦΠΑ",
      visible: true,
      columnOrder: 11,
      isDraggable: false,
      columnDataType: "Double",
      columnFooter: <>{footerData?.actualFees}</>
    },
    {
      columnName: "oteConType",
      columnDisplayName: "Είδος Σύνδεσης",
      visible: true,
      columnOrder: 12,
      isDraggable: false,
      columnDataType: "String",
    }
  ];
}